import smallLogo from "../images/logo-quantum-small-v2.svg";
import etherscan from "../images/etherscan-logo-light-circle.svg";

export default function Footer() {
  return (
    <>
      <footer className="footer bg--primary-color py-5">
        <div className="footer__wrapper padding-top padding-bottom">
          <div className="container">
            <div className="footer__content text-center">
              <a className="mb-4 d-inline-block" href="index.html">
                <img src={smallLogo} alt="logo" width={100} height={100} />
              </a>
              <ul className="social justify-content-center">
                <li className="social__item">
                  <a
                    href="https://twitter.com/QTEtoken"
                    className="social__link"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                </li>
                <li className="social__item">
                  <a
                    href="https://t.me/QuantumEnergyOfficial"
                    className="social__link"
                  >
                    <i className="bi bi-telegram"></i>
                  </a>
                </li>
                <li className="social__item">
                  <a
                    href="https://etherscan.io/token/0xe89A194D366A3f18B06Ced6474DC7dAba66EFa83"
                    className="social__link"
                  >
                    <img
                      className="social__link etherscan"
                      src={etherscan}
                      alt="etherscan"
                      width={50}
                      height={50}
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer__copyright">
          <div className="container">
            <div className="text-center py-4">
              <p className="pb-1">
                <sup>&copy;</sup> 2023 | Quantum Energy. All Rights Reserved |{" "}
                <a href="mailto:devteam@qtenergy.io">Email Dev Team</a>
              </p>
              <p className="pb-3">
                CA:{" "}
                <a
                  href="https://etherscan.io/token/0xe89A194D366A3f18B06Ced6474DC7dAba66EFa83"
                  target="_blank"
                >
                  0xe89A194D366A3f18B06Ced6474DC7dAba66EFa83
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
